import { render } from "./PVTPrediction.vue?vue&type=template&id=f354a94c&scoped=true"
import script from "./PVTPrediction.vue?vue&type=script&lang=js"
export * from "./PVTPrediction.vue?vue&type=script&lang=js"

import "./PVTPrediction.vue?vue&type=style&index=0&id=f354a94c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f354a94c"]])

export default __exports__